import _ from 'lodash'
import BaseNonDatasetReportForm from '../common/base-non-dataset-report-form'
import ScorecardFilterMeta from '../wizard/filter-meta/scorecard-filter-meta'
import filterExplanationBanner from 'scoreboard/reports/scorecard-report/scorecard-report-filter-explanation-banner.hbs'
import ScorecardReportTableModel from './scorecard-report-table-model'

const ScorecardReportForm = BaseNonDatasetReportForm.extend({

	recordTypeCode: 'scorecards.scorecardNodes',

	_filterMeta: ScorecardFilterMeta,

	_filterTitle: 'report.customReport.title',

	_filterBanner: function() {
		return filterExplanationBanner()
	},

	_editPeriodRangeOptions: function() {
	},

	_reportTableModel() {
		return ScorecardReportTableModel
	},

	remove() {
		BaseNonDatasetReportForm.prototype.remove.apply(this, arguments)
		_.invokeMap([this.wizard], 'remove')
	}

})

export default ScorecardReportForm

ScorecardReportForm.__filename__ = 'reports/scorecard-report/scorecard-report-form.js'
